import { StringUtil } from "@eres/core";
import { CommitteeDoc, OwnerCommitteeDocument } from "../ownercommitteeapi/entities";
import { formatAppDate } from "./Utils";

export enum CommitteeDocTypes {
	IMAGE = 1,
	PDF = 2,
}

export function getCommitteeDocType( committeeDoc: CommitteeDoc ) {
	let type = CommitteeDocTypes.PDF;
	let fileUrl = committeeDoc.fileUrl;
	let localData = committeeDoc.localData;
	if ( fileUrl && !StringUtil.isEmptyStringOrNull( fileUrl ) ) {
		fileUrl = fileUrl.toLocaleLowerCase();
		if ( fileUrl.endsWith( ".png" ) || fileUrl.endsWith( ".jpg" ) )
			type = CommitteeDocTypes.IMAGE;
	} else if ( localData && !StringUtil.isEmptyStringOrNull( localData ) ) {
		const d = localData.split( ";" )[ 0 ];
		if ( d.includes( "image" ) )
			type = CommitteeDocTypes.IMAGE;
	}
	return type;
}

export function getCommitteeDocName( committeeDoc: CommitteeDoc ) {
	let fileUrl = committeeDoc.fileUrl;
	if ( fileUrl && !StringUtil.isEmptyStringOrNull( fileUrl ) )
		return fileUrl.substring( fileUrl.lastIndexOf( "/" ) + 1, fileUrl.length );
	return committeeDoc.fileName;
}

export function getCommitteeDocSize( committeeDoc: CommitteeDoc ) {
	let size = committeeDoc.fileSize;
	if ( size && size > 0 ) {
		return parseFloat( "" + ( size / ( 1024 * 1024 ) ) ).toFixed( 2 );
	}
	return "";
}

export function getCommitteeDocMaxSize( committeeDoc: OwnerCommitteeDocument ) {
	let size = committeeDoc.maxSize;
	if ( size && size > 0 ) {
		return parseFloat( "" + ( size / ( 1024 * 1024 ) ) ).toFixed( 0 );
	}
	return "";
}

export function getCommitteeDocDate( committeeDoc: CommitteeDoc ) {
	let localData = committeeDoc.localData;
	if ( localData && !StringUtil.isEmptyStringOrNull( localData ) ) {
		return formatAppDate( new Date(), "en" );
	}
	return "";
}
